import { createFileRoute } from '@tanstack/react-router';

import { SettingsScreen } from '../../features/settings/SettingsScreen';
import { validateSettingsSearch } from '../../features/settings/search';

/**
 * `/settings` (§6.9). المسار رقيق بحكم البنية: التبويب يعيش في search params
 * (§1.2 — الرابط قابل للمشاركة، والرجوع بالتاريخ يحفظ التبويب المفتوح)، وكل
 * التركيب في `features/settings`.
 *
 * الاستيرادان منفصلان بحكم الميزانية لا بحكم الذوق: `validateSearch` خيار مسار
 * يبقى في الحزمة الابتدائية، و`SettingsScreen` مكوّن يؤجّله `autoCodeSplitting`.
 * سحبهما من ملف واحد كان يُبطل التأجيل ويُغرق المدخل بالشاشة كاملة — انظر
 * `features/settings/search.ts`.
 */
export const Route = createFileRoute('/settings/')({
  validateSearch: validateSettingsSearch,
  component: SettingsRoute,
});

function SettingsRoute() {
  const { tab, commerce, detail } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <SettingsScreen
      tab={tab}
      commerce={commerce}
      detail={detail}
      onTabChange={(next) => void navigate({ search: { tab: next } })}
    />
  );
}
